import { render, staticRenderFns } from "./before-after.vue?vue&type=template&id=abbfd2d8&"
import script from "./before-after.vue?vue&type=script&lang=js&"
export * from "./before-after.vue?vue&type=script&lang=js&"
import style0 from "./before-after.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports